export const GetCustomFields = async (token) => {
  let result;
  try {
    const response = await fetch(`/getFields`, {
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
    });

    const result = response.json();
    return result;
  } catch (ex) {
    console.log(ex.message);
  }
  return result;
};

export const SearchIssues = async (token, jql) => {
  let result;
  const jsonData = JSON.stringify({ jql: jql });

  try {
    const response = await fetch(`/searchIssues`, {
      method: 'post',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: jsonData,
    });

    const result = response.json();
    return result;
  } catch (ex) {
    console.log(ex.message);
  }
  return result;
};

export const GetRequestTypes = async () => {
  let result;
  try {
    await window.AP.request(`/rest/servicedeskapi/requesttype?limit=1000`, {
      experimental: true,
    })
      .then((data) => {
        let json = JSON.parse(data.body);
        result = json.values;
      })
      .catch((e) => console.log(e.err));
  } catch (ex) {
    console.log(ex.message);
  }
  return result;
};
